<template>
  <Loading :loading="loading" text="报表数据计算中..."/>
  <vxe-toolbar class-name="px-8px">
    <template #buttons>
      <DatePicker v-if="dimension==='QUARTER'" v-model="voucherDate" type="quarter" :clearable="false"/>
      <account-date-choose v-else v-model="voucherDate"/>
    </template>
    <template #tools>
      <vxe-button :loading="dloading" @click="exportData" icon="fa fa-download" content="导出"/>
      <vxe-button @click="printPDF" icon="fa fa-print" content="打印"/>
    </template>
  </vxe-toolbar>
  <div id="printSection" ref="reportContent" style="overflow: auto">
    <table class="cus-table" style="min-width: 100%">
      <thead class="header">
        <tr>
          <td>项目</td>
          <td colspan="2">股金</td>
          <td colspan="2">专项基金</td>
          <td colspan="2">资本公积</td>
          <td colspan="2">盈余公积</td>
          <td colspan="2">未分配盈余</td>
          <td>合计</td>
        </tr>
      </thead>
      <tr>
        <td class="text-left">年初余额</td>
        <td colspan="2" class="text-right">{{ seachData('股金年初余额','年初余额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('专项基金年初余额','年初余额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('资本公积年初余额','年初余额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('盈余公积年初余额','年初余额') }}</td>
        <td colspan="2" class="text-right">{{ (Number(seachData('盈余分配-未分配盈余年初余额','年初余额')) + Number(seachData('本年盈余余额','年初余额'))).toFixed(2) }}</td>
        <td class="text-right">{{ (Number(seachData('股金年初余额','年初余额')) +  Number(seachData('专项基金年初余额','年初余额')) + Number(seachData('资本公积年初余额','年初余额')) + Number(seachData('盈余公积年初余额','年初余额')) + Number(seachData('盈余分配-未分配盈余年初余额','年初余额'))).toFixed(2) }}</td>
      </tr>
      <tr>
        <td class="text-left">本年增加</td>
        <td colspan="2" class="text-right">{{ seachData('股金贷方发生额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('专项基金贷方发生额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('资本公积贷方发生额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('盈余公积贷方发生额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('盈余分配-未分配盈余贷方发生额','本年金额') }}</td>
        <td class="text-right">{{ (Number(seachData('股金贷方发生额','本年金额')) + Number(seachData('专项基金贷方发生额','本年金额')) + Number(seachData('资本公积贷方发生额','本年金额')) + Number(seachData('盈余公积贷方发生额','本年金额')) + Number(seachData('盈余分配-未分配盈余贷方发生额','本年金额'))).toFixed(2) }}</td>
      </tr>
      <tr>
        <td class="text-left"></td>
        <td colspan="2" class="text-left">其中：</td>
        <td colspan="2" class="text-left">其中：</td>
        <td colspan="2" class="text-left">其中：</td>
        <td colspan="2" class="text-left">其中：</td>
        <td colspan="2" class="text-left"></td>
        <td class="text-left"></td>
      </tr>
      <tr>
        <td style="width: 120px;" class="text-left"></td>
        <td style="width: 120px;" class="text-left">资本公积转赠</td>
        <td style="width: 120px;" class="text-right">{{ seachData('资本公积转赠贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-left">国家财政直接补助</td>
        <td style="width: 120px;" class="text-right">{{ seachData('国家财政补助贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-left">股金溢价</td>
        <td style="width: 120px;" class="text-right">{{ seachData('股金溢价贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-left">从盈余中提取</td>
        <td style="width: 120px;" class="text-left">{{ seachData('盈余公积贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-left">本年盈余</td>
        <td style="width: 120px;" class="text-right">{{ seachData('本年盈余贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-right">{{ (Number(seachData('资本公积转赠贷方发生额','本年金额')) + Number(seachData('国家财政补助贷方发生额','本年金额')) + Number(seachData('股金溢价贷方发生额','本年金额')) + Number(seachData('盈余公积贷方发生额','本年金额')) + Number(seachData('本年盈余贷方发生额','本年金额'))).toFixed(2) }}</td>
      </tr>
      <tr>
        <td style="width: 120px;" class="text-left"></td>
        <td style="width: 120px;" class="text-left">盈余公积转赠</td>
        <td style="width: 120px;" class="text-right">{{ seachData('盈余公积转赠贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-left">接收捐赠转入</td>
        <td style="width: 120px;" class="text-right">{{ seachData('接受捐赠转入贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-left">资产评估增值</td>
        <td style="width: 120px;" class="text-right">{{ seachData('资产评估增值贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" class="text-left">其他转入</td>
        <td style="width: 120px;" class="text-right">{{ seachData('其他转入贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-right">{{ (Number(seachData('盈余公积转赠贷方发生额','本年金额')+Number(seachData('接受捐赠转入贷方发生额','本年金额')) + Number(seachData('资产评估增值贷方发生额','本年金额')) + Number(seachData('其他转入贷方发生额','本年金额')))).toFixed(2) }}</td>
      </tr>
      <tr>
        <td style="width: 120px;" class="text-left"></td>
        <td style="width: 120px;" class="text-left">成员增加出资</td>
        <td style="width: 120px;" class="text-right">{{ seachData('成员增加出资贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" class="text-right">{{ seachData('成员增加出资贷方发生额','本年金额') }}</td>
      </tr>  
      <tr>
        <td class="text-left">本年减少数</td>
        <td colspan="2" class="text-right">{{ seachData('股金借方发生额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('专项基金借方发生额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('资本公积借方发生额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('盈余公积借方发生额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('盈余分配-未分配盈余借方发生额','本年金额') }}</td>
        <td class="text-right">{{ (Number(seachData('股金借方发生额','本年金额')) + Number(seachData('专项基金借方发生额','本年金额')) + Number(seachData('资本公积借方发生额','本年金额')) + Number(seachData('盈余公积借方发生额','本年金额')) + Number(seachData('盈余分配-未分配盈余借方发生额','本年金额'))).toFixed(2) }}</td>
      </tr>
      <tr>
        <td class="text-left"></td>
        <td colspan="2" class="text-left">其中：</td>
        <td colspan="2" class="text-left"></td>
        <td colspan="2" class="text-left">其中：</td>
        <td colspan="2" class="text-left">其中：</td>
        <td colspan="2" class="text-left"></td>
        <td class="text-left"></td>
      </tr>
      <tr>
        <td style="width: 120px;" class="text-left"></td>
        <td style="width: 120px;" class="text-left">成员减少出资</td>
        <td style="width: 120px;" class="text-right">{{ seachData('成员增加出资借方发生额','本年金额') }}</td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" class="text-left">转为成员出资</td>
        <td style="width: 120px;" class="text-right">{{ seachData('资本公积转赠贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-left">转为成员出资</td>
        <td style="width: 120px;" class="text-left">{{ seachData('盈余公积转赠贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-left">提取盈余公积</td>
        <td style="width: 120px;" class="text-right">{{ seachData('提取盈余公积借方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-right">{{ (Number(seachData('成员增加出资借方发生额','本年金额')) + Number(seachData('资本公积转赠贷方发生额','本年金额')) + Number(seachData('盈余公积转赠贷方发生额','本年金额')) + Number(seachData('提取盈余公积借方发生额','本年金额'))).toFixed(2) }}</td>
      </tr>
      <tr>
        <td style="width: 120px;" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" class="text-left">弥补亏损</td>
        <td style="width: 120px;" class="text-right">{{ seachData('弥补亏损借方发生额','本年金额') }}</td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" class="text-left">盈余返还</td>
        <td style="width: 120px;" class="text-right">{{ seachData('盈余返还借方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-right">{{ (Number(seachData('弥补亏损借方发生额','本年金额')) + Number(seachData('盈余返还借方发生额','本年金额'))).toFixed(2) }}</td>
      </tr>
      <tr>
        <td style="width: 120px;" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" class="text-left">剩余盈余分配</td>
        <td style="width: 120px;" class="text-right">{{ seachData('剩余盈余分配借方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-right">{{ seachData('剩余盈余分配借方发生额','本年金额') }}</td>
      </tr>
      <tr>
        <td style="width: 120px;" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" class="text-left">转为成员出资</td>
        <td style="width: 120px;" class="text-right">{{ seachData('盈余转成员出资借方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-right">{{ seachData('盈余转成员出资借方发生额','本年金额') }}</td>
      </tr>
      <tr>
        <td class="text-left">年末余额</td>
        <td colspan="2" class="text-right">{{ seachData('股金年初余额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('专项基金年初余额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('资本公积年初余额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('盈余公积年初余额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ (Number(seachData('盈余分配-未分配盈余年初余额','本年金额')) + Number(seachData('本年盈余余额','本年金额'))).toFixed(2) }}</td>
        <td class="text-right">{{ (Number(seachData('股金年初余额','本年金额'))+Number(seachData('专项基金年初余额','本年金额'))+Number(seachData('资本公积年初余额','本年金额'))+Number(seachData('盈余公积年初余额','本年金额') )+Number(seachData('盈余分配-未分配盈余年初余额','本年金额'))+Number(seachData('本年盈余余额','本年金额'))).toFixed(2) }}</td>
      </tr>
    </table>
  </div>
  <!-- 打印格式 -->
  <!-- <div ref="reportContentPrint" id="reportContentPrint" style="position: absolute; left: -9999px; top: -9999px;"> -->
    <div ref="reportContentPrint" id="reportContentPrint" style="position: absolute; left: -9999px; top: -9999px;padding:20px;">
    <h1 style="text-align: center;">成员权益变动表</h1>
    <p style="text-align: right;">会农合03表</p>
    <div style="display: flex;justify-content: space-between;margin-bottom: 10px;">
        <div class="info-item">单位：<span>{{ accountSetsName }}</span></div>
        <div class="info-item">时间：<span>{{ manba(voucherDate.value).format('YYYY年MM月') }}</span></div>
        <div class="info-item">单位：元</div>
    </div>
    <table id="printSectionPrint" class="cus-table" style="min-width: 100%">
      <thead class="header">
        <tr>
          <td>项目</td>
          <td colspan="2">股金</td>
          <td colspan="2">专项基金</td>
          <td colspan="2">资本公积</td>
          <td colspan="2">盈余公积</td>
          <td colspan="2">未分配盈余</td>
          <td>合计</td>
        </tr>
      </thead>
      <tr>
        <td class="text-left">年初余额</td>
        <td colspan="2" class="text-right">{{ seachData('股金年初余额','年初余额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('专项基金年初余额','年初余额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('资本公积年初余额','年初余额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('盈余公积年初余额','年初余额') }}</td>
        <td colspan="2" class="text-right">{{ (Number(seachData('盈余分配-未分配盈余年初余额','年初余额')) + Number(seachData('本年盈余余额','年初余额'))).toFixed(2) }}</td>
        <td class="text-right">{{ (Number(seachData('股金年初余额','年初余额')) +  Number(seachData('专项基金年初余额','年初余额')) + Number(seachData('资本公积年初余额','年初余额')) + Number(seachData('盈余公积年初余额','年初余额')) + Number(seachData('盈余分配-未分配盈余年初余额','年初余额'))).toFixed(2) }}</td>
      </tr>
      <tr>
        <td class="text-left">本年增加</td>
        <td colspan="2" class="text-right">{{ seachData('股金贷方发生额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('专项基金贷方发生额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('资本公积贷方发生额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('盈余公积贷方发生额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('盈余分配-未分配盈余贷方发生额','本年金额') }}</td>
        <td class="text-right">{{ (Number(seachData('股金贷方发生额','本年金额')) + Number(seachData('专项基金贷方发生额','本年金额')) + Number(seachData('资本公积贷方发生额','本年金额')) + Number(seachData('盈余公积贷方发生额','本年金额')) + Number(seachData('盈余分配-未分配盈余贷方发生额','本年金额'))).toFixed(2) }}</td>
      </tr>
      <tr>
        <td class="text-left"></td>
        <td colspan="2" class="text-left">其中：</td>
        <td colspan="2" class="text-left">其中：</td>
        <td colspan="2" class="text-left">其中：</td>
        <td colspan="2" class="text-left">其中：</td>
        <td colspan="2" class="text-left"></td>
        <td class="text-left"></td>
      </tr>
      <tr>
        <td style="width: 120px;" class="text-left"></td>
        <td style="width: 120px;" class="text-left">资本公积转赠</td>
        <td style="width: 120px;" class="text-right">{{ seachData('资本公积转赠贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-left">国家财政直接补助</td>
        <td style="width: 120px;" class="text-right">{{ seachData('国家财政补助贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-left">股金溢价</td>
        <td style="width: 120px;" class="text-right">{{ seachData('股金溢价贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-left">从盈余中提取</td>
        <td style="width: 120px;" class="text-left">{{ seachData('盈余公积贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-left">本年盈余</td>
        <td style="width: 120px;" class="text-right">{{ seachData('本年盈余贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-right">{{ (Number(seachData('资本公积转赠贷方发生额','本年金额')) + Number(seachData('国家财政补助贷方发生额','本年金额')) + Number(seachData('股金溢价贷方发生额','本年金额')) + Number(seachData('盈余公积贷方发生额','本年金额')) + Number(seachData('本年盈余贷方发生额','本年金额'))).toFixed(2) }}</td>
      </tr>
      <tr>
        <td style="width: 120px;" class="text-left"></td>
        <td style="width: 120px;" class="text-left">盈余公积转赠</td>
        <td style="width: 120px;" class="text-right">{{ seachData('盈余公积转赠贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-left">接收捐赠转入</td>
        <td style="width: 120px;" class="text-right">{{ seachData('接受捐赠转入贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-left">资产评估增值</td>
        <td style="width: 120px;" class="text-right">{{ seachData('资产评估增值贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" class="text-left">其他转入</td>
        <td style="width: 120px;" class="text-right">{{ seachData('其他转入贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-right">{{ (Number(seachData('盈余公积转赠贷方发生额','本年金额')+Number(seachData('接受捐赠转入贷方发生额','本年金额')) + Number(seachData('资产评估增值贷方发生额','本年金额')) + Number(seachData('其他转入贷方发生额','本年金额')))).toFixed(2) }}</td>
      </tr>
      <tr>
        <td style="width: 120px;" class="text-left"></td>
        <td style="width: 120px;" class="text-left">成员增加出资</td>
        <td style="width: 120px;" class="text-right">{{ seachData('成员增加出资贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" class="text-right">{{ seachData('成员增加出资贷方发生额','本年金额') }}</td>
      </tr>  
      <tr>
        <td class="text-left">本年减少数</td>
        <td colspan="2" class="text-right">{{ seachData('股金借方发生额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('专项基金借方发生额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('资本公积借方发生额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('盈余公积借方发生额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('盈余分配-未分配盈余借方发生额','本年金额') }}</td>
        <td class="text-right">{{ (Number(seachData('股金借方发生额','本年金额')) + Number(seachData('专项基金借方发生额','本年金额')) + Number(seachData('资本公积借方发生额','本年金额')) + Number(seachData('盈余公积借方发生额','本年金额')) + Number(seachData('盈余分配-未分配盈余借方发生额','本年金额'))).toFixed(2) }}</td>
      </tr>
      <tr>
        <td class="text-left"></td>
        <td colspan="2" class="text-left">其中：</td>
        <td colspan="2" class="text-left"></td>
        <td colspan="2" class="text-left">其中：</td>
        <td colspan="2" class="text-left">其中：</td>
        <td colspan="2" class="text-left"></td>
        <td class="text-left"></td>
      </tr>
      <tr>
        <td style="width: 120px;" class="text-left"></td>
        <td style="width: 120px;" class="text-left">成员减少出资</td>
        <td style="width: 120px;" class="text-right">{{ seachData('成员增加出资借方发生额','本年金额') }}</td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" class="text-left">转为成员出资</td>
        <td style="width: 120px;" class="text-right">{{ seachData('资本公积转赠贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-left">转为成员出资</td>
        <td style="width: 120px;" class="text-left">{{ seachData('盈余公积转赠贷方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-left">提取盈余公积</td>
        <td style="width: 120px;" class="text-right">{{ seachData('提取盈余公积借方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-right">{{ (Number(seachData('成员增加出资借方发生额','本年金额')) + Number(seachData('资本公积转赠贷方发生额','本年金额')) + Number(seachData('盈余公积转赠贷方发生额','本年金额')) + Number(seachData('提取盈余公积借方发生额','本年金额'))).toFixed(2) }}</td>
      </tr>
      <tr>
        <td style="width: 120px;" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" class="text-left">弥补亏损</td>
        <td style="width: 120px;" class="text-right">{{ seachData('弥补亏损借方发生额','本年金额') }}</td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" class="text-left">盈余返还</td>
        <td style="width: 120px;" class="text-right">{{ seachData('盈余返还借方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-right">{{ (Number(seachData('弥补亏损借方发生额','本年金额')) + Number(seachData('盈余返还借方发生额','本年金额'))).toFixed(2) }}</td>
      </tr>
      <tr>
        <td style="width: 120px;" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" class="text-left">剩余盈余分配</td>
        <td style="width: 120px;" class="text-right">{{ seachData('剩余盈余分配借方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-right">{{ seachData('剩余盈余分配借方发生额','本年金额') }}</td>
      </tr>
      <tr>
        <td style="width: 120px;" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" colspan="2" class="text-left"></td>
        <td style="width: 120px;" class="text-left">转为成员出资</td>
        <td style="width: 120px;" class="text-right">{{ seachData('盈余转成员出资借方发生额','本年金额') }}</td>
        <td style="width: 120px;" class="text-right">{{ seachData('盈余转成员出资借方发生额','本年金额') }}</td>
      </tr>
      <tr>
        <td class="text-left">年末余额</td>
        <td colspan="2" class="text-right">{{ seachData('股金年初余额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('专项基金年初余额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('资本公积年初余额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ seachData('盈余公积年初余额','本年金额') }}</td>
        <td colspan="2" class="text-right">{{ (Number(seachData('盈余分配-未分配盈余年初余额','本年金额')) + Number(seachData('本年盈余余额','本年金额'))).toFixed(2) }}</td>
        <td class="text-right">{{ (Number(seachData('股金年初余额','本年金额'))+Number(seachData('专项基金年初余额','本年金额'))+Number(seachData('资本公积年初余额','本年金额'))+Number(seachData('盈余公积年初余额','本年金额') )+Number(seachData('盈余分配-未分配盈余年初余额','本年金额'))+Number(seachData('本年盈余余额','本年金额'))).toFixed(2) }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "BmlrReportView"
}
</script>

<script setup>

import ReportApi from "@/api/report";
import {ref, toRefs, watch} from "vue";
import {toArrayTree} from "xe-utils";
import ReportRow from "@/views/report/view/ReportRow";
import {useStore} from "vuex";
import manba from "manba";
import setting from "@/api/setting";
import jQuery from "jquery";
import Report from "@/api/report";
import {downloadBlob} from "download.js";
import htmlToExcel from '@/utils/htmlToExcel'; // 直接导入 htmlToExcel 函数 
import html2canvas from 'html2canvas';
import print from "@js/common/print";
const store = useStore();
const {currentAccountSets} = store.state

const props = defineProps(['report', 'dimension']);

const {report, dimension} = toRefs(props);
const reportContent = ref(null);
const loading = ref(false);
const dloading = ref(false);
const voucherDate = ref(currentAccountSets.currentAccountDate)
const accountSetsName = ref(currentAccountSets.companyName)

const reportData = ref({})


const items = ref([])

const seachData = (title,type) =>{
  if(Object.keys(reportData.value).length === 0){return ''}
  let result = ''; // 初始化结果变量
  Object.keys(reportData.value).forEach(key => {
      // console.log(reportData.value[key]);
      if(reportData.value[key].title === title){
        switch (type) {
          case '年初余额':
           result = reportData.value[key].values.年初金额.toFixed(2);
          break;
          case '本年金额':
           result = reportData.value[key].values.本年金额.toFixed(2);
          break;
          case '本期金额':
           result = reportData.value[key].values.本期金额.toFixed(2);
          break;
        }
        
      }
  });
  return result;
}

const loadData = () => {
  // ReportApi.view(report.value.templateKey, {
	// 	voucherDate: voucherDate.value,
	// 	dimension: dimension.value
	// }).then(({data}) => {
  loading.value = true;
  ReportApi.view(report.value.templateKey, {
    voucherDate:voucherDate.value,
    dimension: dimension.value
  }).then(({data}) => {
    reportData.value = Object.assign(reportData.value, data);
    // console.log(reportData.value)
  }).finally(() => loading.value = false);
}
loadData()
watch(voucherDate, () => {
  loadData();
})


// 添加打印PDF函数
const printPDF = async () => {
  try {
    // loading.value = true;
    const element = document.getElementById('reportContentPrint');
    
    // 使用html2canvas将表格转换为图片
    const canvas = await html2canvas(element, {
      scale: 2, // 提高清晰度
      useCORS: true, // 允许跨域图片
      logging: false, // 关闭日志
      backgroundColor: '#FFFFFF' // 白色背景
    });
    
    // 将canvas转换为图片数据
    const imgData = canvas.toDataURL('image/png');
    
    // 使用您的PDF工具创建PDF
    const pdf = await print.print({ orientation: 'l' }); // 横向布局
    
    // 获取图片尺寸 (毫米)
    const imgWidth = canvas.width * 0.264583; // px转mm
    const imgHeight = canvas.height * 0.264583;
    
    // 计算PDF页面尺寸
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    
    // 计算缩放比例以适应页面
    const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
    const scaledWidth = imgWidth * ratio;
    const scaledHeight = imgHeight * ratio;
    
    // 居中位置计算
    const x = (pdfWidth - scaledWidth) / 2;
    const y = (pdfHeight - scaledHeight) / 2;
    
    // 添加图片到PDF
    pdf.addImage(imgData, 'PNG', x, y, scaledWidth, scaledHeight);
    
    // // 保存PDF
    // pdf.save(`成员权益变动表_${new Date().toISOString().slice(0, 10)}.pdf`);
    // 在新窗口中打开 PDF（不下载）
    window.open(pdf.output('bloburl'), '_blank');
  } catch (error) {
    console.error('打印失败:', error);
  } finally {
    // loading.value = false;
  }
};


const exportData = () => {
  htmlToExcel.exportExcel("成员权益变动表.xlsx", "#printSection");
  // const clone = jQuery(reportContent.value).clone();
  // clone.find('.report-edit-formulas').remove()
  // let dataList = [];
  // clone.find("tr").each((idx, tr) => {
  //   let row = [];
  //   jQuery(tr).find('td').each((idx, td) => {
  //     let val = jQuery(td).data('val');
  //     let lv = jQuery(td).data('lv') || 0;
  //     if (!val || val === '-0') {
  //       val = jQuery(td).text();
  //     }
  //     for (let i = 0; i < lv; i++) {
  //       val = "    " + val
  //     }
  //     row.push(val)
  //   })
  //   dataList.push(row);
  // })
  // dloading.value = true;
  // Report.download({
  //   title: '部门利润' + (dimension.value === 'QUARTER' ? '季报' : ''),
  //   voucherDate: voucherDate.value,
  //   accountSetsName: `编制单位：${accountSetsName.value}`,
  //   dataList
  // }).then((data) => {
  //   downloadBlob(manba().format("YYYYMMDDhhmmss") + "部门利润" + (dimension.value === 'QUARTER' ? '季报' : '') + ".xls", data)
  // }).finally(() => dloading.value = false)
}
</script>
